import { useRef } from 'react';
import { useHandleSubmitError } from '@/components/DashboardComponents'
import { useNavigate, useLoaderData, Form, useSubmit } from 'react-router'
import { RubricEditor } from '@/pages/RubricLayout';

export function NewRubricLayout() {
  const navigate = useNavigate();
  const rubric = useLoaderData().data?.value;
  // const { rubric_id } = useParams();
  const submit = useSubmit();
  const form = useRef();
  // const submitting = useIsFormSubmitting();
  useHandleSubmitError();

  function submitCallback({ rubric }) {
    submit({ ...rubric }, { method: "post", encType: "application/json" });
  }

  return (
    <Form id="create_scenario" method="post" ref={form} onSubmit={(event) => event.preventDefault()}>
      <div className="dashboard_container">
        <RubricEditor goBackCallback={() => {navigate(-1)}} rubric={rubric} from_scenario_editor={false} submitCallback={submitCallback}/>
      </div>
    </Form>
  )
}